<script setup lang="ts">
import { cn } from '@/lib/utils';
import type { Markets } from '@/types';

interface Props {
  variant?: Markets[number];
}

withDefaults(defineProps<Props>(), {
  variant: 'agriculture',
});

const urls: { [key: string]: URL } = {};
const getPoiPin = (variant: Markets[number]) => {
  const key = `poiPin-${variant}`;
  if (!(key in urls)) {
    urls[key] = new URL(`/src/assets/images/Pois/${variant}.svg`, import.meta.url);
  }

  return urls[key].href;
};
</script>

<template>
  <button :class="cn('', $attrs.class ?? '')">
    <img :src="getPoiPin(variant)" alt="" />
  </button>
</template>
